import * as THREE from 'three';

// Grade palette aligned to BlockModels.js
export const BLOCK_MODEL_GRADE_PALETTE = Object.freeze({
  selected: 0xfff200,
  thresholds: [
    { min: 3, color: 0xac02b4 },
    { min: 1.5, color: 0xff0000 },
    { min: 0.6, color: 0x00ff00 },
    { min: -Infinity, color: 0x0000ff }
  ]
});

export function getGradeColorHexFromBlockModelPalette(value) {
  const v = Number(value);
  if (!Number.isFinite(v)) return BLOCK_MODEL_GRADE_PALETTE.thresholds[BLOCK_MODEL_GRADE_PALETTE.thresholds.length - 1].color;
  for (let i = 0; i < BLOCK_MODEL_GRADE_PALETTE.thresholds.length; i += 1) {
    const t = BLOCK_MODEL_GRADE_PALETTE.thresholds[i];
    if (v >= t.min) return t.color;
  }
  return BLOCK_MODEL_GRADE_PALETTE.thresholds[BLOCK_MODEL_GRADE_PALETTE.thresholds.length - 1].color;
}

export function getGradeColorFromBlockModelPalette(value) {
  return new THREE.Color(getGradeColorHexFromBlockModelPalette(value));
}

